import {
  Box,
  Container,
  Typography
} from '@mui/material';
import ScreenHeader from 'src/common/ScreenHeader';
import getStaticAssetUrl from 'src/utils/getStaticAssetUrl';
import { LayoutWrapper } from './Login';

const NotFound = () => (
  <LayoutWrapper>
    <ScreenHeader title="404" />
    <Box
      sx={{
        backgroundColor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center'
      }}
    >
      <Container maxWidth="md">
        <Typography
          align="center"
          color="textPrimary"
          variant="h1"
        >
          404: The page you are looking for isn’t here
        </Typography>
        <Typography
          align="center"
          color="textPrimary"
          variant="subtitle2"
        >
          You either tried some wrong route or you came here by mistake.
          Whichever it is, try using the navigation
        </Typography>
        <Box sx={{ textAlign: 'center' }}>
          <img
            alt="Under development"
            src={getStaticAssetUrl('/static/images/not_found.png')}
            className="csp-not-found-image"
          />
        </Box>
      </Container>
    </Box>
  </LayoutWrapper>
);

export default NotFound;
